import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { serverurl } from '../../environments/environment';
import { SnackService } from './snack.service';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { CreatePdfByHtmlResponse } from '../interfaces/responsedata.ts/pdf';
import { Orientation } from '../interfaces/responsedata.ts/orientation';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  // .pdf, .txt, .rtf, .md, .csv, .json"
  allowedTypes = [
    'application/pdf',
    'text/plain',
    'application/rtf',
    'text/markdown',
    'text/csv',
    'application/json',
  ];

  constructor(
    private http: HttpClient,
    private snack: SnackService,
  ) {}

  //
  // ToDo: add Tags for FileContext:
  // pitch deck
  // scientific paper
  // user research
  // competitor report
  // market report
  // industry trends
  //

  async uploadForHtmlClosings(
    file: File,
    streamId: string,
    stepId: string,
    fileId: string | undefined,
  ): Promise<string | false> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('streamId', streamId);
    formData.append('stepId', stepId);
    if (fileId) {
      formData.append('fileId', fileId);
    }
    console.log(file);

    return await new Promise((resolve) => {
      this.http
        .post(`${serverurl}/knowledgehub/generic-closing-upload`, formData)
        .subscribe({
          next: (data: any) => {
            resolve(data.id);
          },
          error: (err) => {
            this.snack.error(err);
            resolve(false);
          },
        });
    });
  }

  async uploadPdfForTextExtract(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);

    return await new Promise((resolve) => {
      this.http
        .post(`${serverurl}/knowledgehub/pdfextract`, formData)
        .subscribe({
          next: (data) => {
            resolve(data);
          },
          error: (err) => {
            this.snack.error(err);
            resolve(false);
          },
        });
    });
  }
  uploadFile(
    file: File,
    hubId: string,
    fileType: string | null,
  ): Observable<number | boolean> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('hubId', hubId);
    formData.append('fileType', fileType || 'RAGFILE');

    return this.http
      .post(`${serverurl}/knowledgehub/uploads`, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        map((event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                return Math.round((100 * event.loaded) / event.total);
              }
              return 0;
            case HttpEventType.Response:
              return true;
            default:
              return 0;
          }
        }),
      );
  }
  async createPdfByHtml(
    blob: Blob,
    textData: any,
    orientation: Orientation,
  ): Promise<false | CreatePdfByHtmlResponse> {
    // Convert Blob to Base64
    const base64 = await new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = (reader.result as string).split(',')[1]; // Remove data:image/png;base64, prefix
        resolve(base64String);
      };
      reader.readAsDataURL(blob);
    });

    return await new Promise((resolve) => {
      this.http
        .post(`${serverurl}/knowledgehub/createpdf-html`, {
          blob: base64,
          textData,
          orientation,
        })
        .subscribe({
          next: (data: any) => {
            this.snack.success(data.msg);
            resolve(data as CreatePdfByHtmlResponse);
          },
          error: (error) => {
            this.snack.error(error);
            resolve(false);
          },
        });
    });
  }
  async deleteFile(fileId: string): Promise<boolean> {
    return await new Promise((resolve) => {
      this.http.delete(`${serverurl}/knowledgehub/${fileId}`).subscribe({
        next: (data) => {
          resolve(true);
        },
        error: (error) => {
          this.snack.error(error);
          resolve(false);
        },
      });
    });
  }

  async getHubFilesByHubId(hubId: string): Promise<any> {
    return await new Promise((resolve) => {
      this.http.get(`${serverurl}/knowledgehub/${hubId}`).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          this.snack.error(error);
          resolve(false);
        },
      });
    });
  }
}
